<template>
  <div class="member">
    <figure>
      <lottie v-if="member.slug" :options="defaultOptions" :height="125" :width="125" v-on:animCreated="handleAnimation" />
      <img v-else :src="member.icoon.url">
    </figure>
    <div class="info">
      <h3>{{member.naam}}</h3>
      <div>{{member.functie}}</div>
      <em v-if="member.quote">“{{member.quote}}”</em>
    </div>
  </div>
</template>

<script>
// import { settings } from '../variables.js'
import Lottie from 'vue-lottie'

export default {
  props: ['member'],
  components: {
    'lottie': Lottie
  },
  data () {
    return {
      icoon: {},
      animationDataComputed: {},
      defaultOptions: { animationData: {}, loop: false, autoPlay: true },
      animationSpeed: 1
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    }
  },
  created () {
    if (this.member.slug) {
      this.defaultOptions.animationData = this.memberAnimation
    }
  },
  computed: {
    memberAnimation () {
      return this.$store.state.teamModule.memberAnimations[this.member.slug]
    }
  }
}
</script>

<style lang="scss">
  .member {
    display: grid;
    grid-template-columns: 2fr 3fr;
    animation-fill-mode: forwards;

    figure {
      // max-width: 200px;
      animation-delay: inherit;
      animation-fill-mode: inherit;

      img {
        max-width: 125px;
        transform: scale(0);
        animation: zoom-in .75s;
        animation-delay: inherit;
        animation-fill-mode: inherit;
        margin: 0px auto;
      }
    }
    .info {
      animation: slide-from-left .75s;
      animation-delay: inherit;
      animation-fill-mode: inherit;
      opacity: 0;
      text-align: left;
    }

    &:nth-of-type(odd) {
      animation-delay: 0;
    }
    &:nth-of-type(even) {
      animation-delay: 0.2s;
    }
    // @for $i from 1 through 16 {
    //   &:nth-of-type(#{$i}) {
    //     animation-delay: #{$i * 0.2}s;
    //   }
    // }
  }

  @keyframes zoom-in {
    from {transform: scale(0);}
    to {transform: scale(1);}
  }
  @keyframes slide-from-left {
    from {
      transform: translateX(-50%);
      opacity: 0;
    }
    to {
      transform: translateX(0%);
      opacity: 1;
    }
  }
</style>
